module.exports = __webpack_public_path__ + "static/media/hands-white.75b5f068.webp";